import React from 'react';

import { toast, ToastContent } from 'react-toastify';

const Message: React.FC<{ msg: string; closeToast: (() => void) | undefined; status: string }> = ({
  msg,
  closeToast,
  status,
}: {
  msg: string;
  closeToast: (() => void) | undefined;
  status: string;
}) => {
  return (
    <div className="flex flex-grow" data-testid={`${status}-msg`}>
      <p className="my-auto">{msg}</p>
      <button type="button" className="my-auto ml-auto" onClick={closeToast}>
        <i className="icon-reject_icon text-xl" />
      </button>
    </div>
  );
};

const Toast = {
  success(msg: string): ToastContent {
    return toast.success(
      ({ closeToast }) => <Message msg={msg} closeToast={closeToast} status="success" />,
      {
        bodyClassName: 'flex flex-grow',
        className: 'flex flex-grow bg-white-1.0 p-4 rounded border-l-8 shadow border-secondary-1.0',
        position: toast.POSITION.BOTTOM_LEFT,
        closeButton: false,
      }
    );
  },
  error(msg: string): ToastContent {
    return toast.error(
      ({ closeToast }) => <Message msg={msg} closeToast={closeToast} status="error" />,
      {
        bodyClassName: 'flex flex-grow',
        className: 'bg-white-1.0 p-4 rounded border-l-8 shadow border-red-1.0',
        position: toast.POSITION.BOTTOM_LEFT,
        closeButton: false,
      }
    );
  },
  warning(msg: string): ToastContent {
    return toast.warn(
      ({ closeToast }) => <Message msg={msg} closeToast={closeToast} status="warning" />,
      {
        bodyClassName: 'flex flex-grow',
        className: 'bg-white-1.0 p-4 rounded border-l-8 shadow border-yellow-1.0',
        position: toast.POSITION.BOTTOM_LEFT,
        closeButton: false,
      }
    );
  },
};

export default Toast;
